var map = {
	"./cc-primary.png": 651,
	"./cc-success.png": 8501,
	"./cc-warning.png": 2064,
	"./chart-success.png": 3081,
	"./chart.png": 6890,
	"./paypal.png": 1918,
	"./wallet-info.png": 5033,
	"./wallet.png": 602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2606;